import * as Sentry from "@sentry/react"
import { createBrowserRouter, Navigate } from "react-router-dom"

import ErrorPage from "./features/error-page"
import RootLayout from "./features/layout/root-layout"
import OrgBootstrap from "./features/org-bootstrap"
import Dashboard from "./features/rotary/dashboard"
import Assessment from "./features/rotary/dashboard/assessment"
import Learning from "./features/rotary/dashboard/learning"
import Teachers from "./features/rotary/dashboard/teachers"
import routes from "./lib/routes"

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

const sentryCreateBrowserRouter = SENTRY_DSN
  ? Sentry.wrapCreateBrowserRouterV6(createBrowserRouter)
  : createBrowserRouter

const router = sentryCreateBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        element: <OrgBootstrap />,
        index: true,
      },
      {
        path: routes.dashboard.base,
        element: <Dashboard />,
        children: [
          {
            element: <Navigate to={"assessment"} replace />,
            index: true,
          },
          {
            path: routes.dashboard.assessment,
            element: <Assessment />,
          },
          {
            path: routes.dashboard.learning,
            element: <Learning />,
          },
        ],
      },
      {
        path: routes.dashboard.teachers,
        element: <Teachers />,
      },
    ],
  },

  {
    path: "*",
    element: <ErrorPage errorStatus={404} />,
  },
])

export default router
